"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_redux_1 = require("react-redux");
var styled_components_1 = __importStar(require("styled-components"));
var ToggleButton = styled_components_1.default.button(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\t", ";\n\tvisibility: ", ";\n\n\tmargin-top: 8px;\n\t:first-child {\n\t\tmargin-top: 0;\n\t}\n"], ["\n\t", ";\n\tvisibility: ", ";\n\n\tmargin-top: 8px;\n\t:first-child {\n\t\tmargin-top: 0;\n\t}\n"])), function (props) { return props.theme.camerabutton; }, function (props) { return props.visible ? "visible" : "hidden"; });
var CameraButton = /** @class */ (function (_super) {
    __extends(CameraButton, _super);
    function CameraButton() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            thumbLoaded: false
        };
        _this.onThumbLoaded = function () {
            _this.setState({ thumbLoaded: true });
        };
        return _this;
    }
    CameraButton.prototype.render = function () {
        if (this.props.image !== null) {
            return (react_1.default.createElement(ToggleButton, { visible: this.state.thumbLoaded, onClick: this.props.onClick },
                react_1.default.createElement("img", { onLoad: this.onThumbLoaded, src: this.props.image, alt: "change camera", "data-automationid": "toggle_camera" })));
        }
        return null;
    };
    return CameraButton;
}(react_1.Component));
var MapStoreToProps = function (store /*, ownProps:any*/) {
    return {
        thumbs: store.UI.thumbs,
    };
};
exports.default = react_redux_1.connect(MapStoreToProps)(styled_components_1.withTheme(CameraButton));
var templateObject_1;
//export default withTheme(CameraControls as any);
//# sourceMappingURL=CameraButton.js.map